import { getContentfulLocale, getUrlLocale } from '@dfds-pax/common'

export interface Content {
  LOGOUT: string
  LOGIN: string
  MY_PROFILE: string
  CREATE_NEW_ACCOUNT: string
  FIRST_TIME_HERE: string
  MENU_ONE_TITLE: string
  MENU_TWO_TITLE: string
  MENU_THREE_TITLE: string
}

export const getContent = async (): Promise<Content> => {
  const urlLocale = getUrlLocale()
  const contentfulLocale = getContentfulLocale(urlLocale)

  const contentUrl = new URL('https://cdn.contentful.com/spaces/z860498abl84/environments/master/entries')
  contentUrl.searchParams.append('content_type', 'paxObResource')
  contentUrl.searchParams.append('locale', contentfulLocale)
  contentUrl.searchParams.append('fields.applications', 'login')
  contentUrl.searchParams.append('limit', '50')

  const response = await fetch(contentUrl.toString(), {
    method: 'GET',
    headers: {
      Authorization: 'Bearer cf3eb41c6603c064c84111798dd42d288c8e0262017997f894653da20797e665',
    },
  })

  const fallbackContent = {
    MENU_ONE_TITLE: 'Personal details',
    MENU_TWO_TITLE: 'My bookings',
    MENU_THREE_TITLE: 'Consent and privacy',
    MY_PROFILE: 'My profile',
    LOGIN: 'Log in',
    FIRST_TIME_HERE: 'First time here?',
    CREATE_NEW_ACCOUNT: 'Create a new account',
    LOGOUT: 'Log out',
  }

  let contentResult

  if (!response.ok) {
    console.error('Login | Error fetching content from Contentful:', response.status, response.statusText)
    return fallbackContent
  } else {
    try {
      contentResult = await response.json()
    } catch (error) {
      console.error('Login | Error parsing JSON response from Contentful:', error)
      return fallbackContent
    } finally {
      return {
        LOGOUT: contentResult.items.find((item: Item) => item.fields.entryTitle === 'LOGOUT')?.fields?.value ?? fallbackContent.LOGOUT,
        LOGIN: contentResult.items.find((item: Item) => item.fields.entryTitle === 'LOGIN')?.fields?.value ?? fallbackContent.LOGIN,
        MY_PROFILE:
          contentResult.items.find((item: Item) => item.fields.entryTitle === 'MY-PROFILE')?.fields?.value ?? fallbackContent.MY_PROFILE,
        CREATE_NEW_ACCOUNT:
          contentResult.items.find((item: Item) => item.fields.entryTitle === 'CREATE-NEW-ACCOUNT')?.fields?.value ??
          fallbackContent.CREATE_NEW_ACCOUNT,
        FIRST_TIME_HERE:
          contentResult.items.find((item: Item) => item.fields.entryTitle === 'FIRST-TIME-HERE')?.fields?.value ??
          fallbackContent.FIRST_TIME_HERE,
        MENU_ONE_TITLE:
          contentResult.items.find((item: Item) => item.fields.entryTitle === 'MENU-ONE-TITLE')?.fields?.value ??
          fallbackContent.MENU_ONE_TITLE,
        MENU_TWO_TITLE:
          contentResult.items.find((item: Item) => item.fields.entryTitle === 'MENU-TWO-TITLE')?.fields?.value ??
          fallbackContent.MENU_TWO_TITLE,
        MENU_THREE_TITLE:
          contentResult.items.find((item: Item) => item.fields.entryTitle === 'MENU-THREE-TITLE')?.fields?.value ??
          fallbackContent.MENU_THREE_TITLE,
      }
    }
  }
}

interface Item {
  fields: {
    entryTitle: string
    value: string
  }
}
